import { render, staticRenderFns } from "./App-block-grade.vue?vue&type=template&id=4e8a2f7f&scoped=true&"
import script from "./App-block-grade.vue?vue&type=script&lang=ts&"
export * from "./App-block-grade.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-grade.vue?vue&type=style&index=0&id=4e8a2f7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a2f7f",
  null
  
)

export default component.exports